/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { GetTruckScheduleCsvMutation, GetTruckScheduleCsvMutationVariables } from "@models/graphql";

const defaultGetTruckScheduleCsvOptions: MutationHookOptions<GetTruckScheduleCsvMutation, GetTruckScheduleCsvMutationVariables> = {};

export const useGetTruckScheduleCsv = (
    options?: MutationHookOptions<GetTruckScheduleCsvMutation, GetTruckScheduleCsvMutationVariables>
) => {
    const [mutation, { data, loading, error }] = useMutation<GetTruckScheduleCsvMutation, GetTruckScheduleCsvMutationVariables>(
        GraphQLDocuments.getTruckScheduleCsv
    );

    const getTruckScheduleCsv = async (variables: GetTruckScheduleCsvMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultGetTruckScheduleCsvOptions,
                ...options,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        getTruckScheduleCsv
    };
};
